import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/course/point"

const coursePoint = {
  getTreeCoursePointList(pageSize, limit, subjectId, keyWord) {
    return axios.get(pre + `/getTreeCoursePointList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          subjectId: subjectId,
          keyWord: keyWord
        }
    });
  },

  coursePointAllList(subjectId) {
    return axios.get(pre + `/coursePointAllList`, {
      params:
        {
          subjectId: subjectId
        }
    });
  },
  coursePointInfo(id) {
    return axios.get(pre + `/coursePointInfo`, {params: {id: id}});
  },
  saveCoursePointSort(params) {
    return axios.post(pre + `/saveCoursePointSort`, qs.stringify(params));
  },
  coursePointDelete(id) {
    return axios.delete(pre + `/coursePointDelete`, {params: {id: id}});
  },
}
export default coursePoint;



// WEBPACK FOOTER //
// ./src/api/course/coursePoint.js